import { render } from "./ExtranetFeatureFlagDetail.vue?vue&type=template&id=a23aa026&scoped=true"
import script from "./ExtranetFeatureFlagDetail.vue?vue&type=script&lang=js"
export * from "./ExtranetFeatureFlagDetail.vue?vue&type=script&lang=js"

import "./ExtranetFeatureFlagDetail.vue?vue&type=style&index=0&id=a23aa026&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23aa026"]])

export default __exports__